// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2JXxj","icon":"SortAdornment_icon__3f6y8","up":"SortAdornment_up__22tIr","down":"SortAdornment_down__3r_JY","active":"SortAdornment_active__20eX2"};